import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { NbMomentDateService } from '@nebular/moment';
import * as Sentry from '@sentry/browser';
import { ToasterConfig } from 'angular2-toaster';
import * as moment from 'moment';
import 'moment/locale/es';
import 'moment/locale/fr';
import 'moment/locale/pt';
import { environment, language } from '../environments/environment';
import { MenuService } from './pages/menu.service';
import { NoticesService } from './shared/services/admin/notices.service';
import { ChatService } from './shared/services/chat/chat.service';
import { MessagingService } from './shared/services/firebase/messaging.service';
import { AuthService } from './shared/services/security/auth.service';
import { UserService } from './shared/services/security/user.service';
//import { SupportService } from './shared/services/support/support.service';
import { SidebarManagerService } from './shared/services/utils/sidebar-manager.service';
import { StylesProvider } from './shared/services/utils/styles.provider';
import { ToastService } from './shared/services/utils/toast.service';
import { TranslatorService } from './shared/services/utils/translator.service';
import { CheckForUpdateService } from './shared/services/worker/check-for-update.service';
import { LogUpdateService } from './shared/services/worker/log-update.service';
import { PromptUpdateService } from './shared/services/worker/prompt-update.service';

@Component({
  selector: 'ngx-app',
  template: `
  <ngx-sample-layout [ngClass]="customStyles">
    <nb-menu [autoCollapse]="true" [items]="menu"></nb-menu>
    <router-outlet></router-outlet>
  </ngx-sample-layout>
    <toaster-container [toasterconfig]="toasterConfig"></toaster-container>
    <ngx-spinner [ngClass]="customStyles"></ngx-spinner>
    <ngx-view-html-modal></ngx-view-html-modal>
    <ngx-email-modal></ngx-email-modal>
    <ngx-potencial-sellers-modal></ngx-potencial-sellers-modal>
    <ngx-send-email></ngx-send-email>
    <div [ngClass]="customStyles">
    <ngx-delete-modal></ngx-delete-modal>
    <ngx-assign-modal></ngx-assign-modal>
    <ngx-transfer-leads-modal></ngx-transfer-leads-modal>
    <ngx-edit-lead-modal></ngx-edit-lead-modal>
    <ngx-new-lead-modal></ngx-new-lead-modal>
    <ngx-assignment-rules-simulator></ngx-assignment-rules-simulator>
    <ngx-send-whatsapp></ngx-send-whatsapp>
    <ngx-on-track></ngx-on-track>
    <ngx-archived-modal></ngx-archived-modal>
    <ngx-reminder-modal></ngx-reminder-modal>
    <ngx-calendar-modal></ngx-calendar-modal>
    <ngx-close-lead-modal></ngx-close-lead-modal>
    <ngx-revert-close-lead-modal></ngx-revert-close-lead-modal>
    <ngx-visit-modal></ngx-visit-modal>
    <ngx-call-modal></ngx-call-modal>
    <ngx-import-csv></ngx-import-csv>
    <ngx-comment-modal></ngx-comment-modal>
    <ngx-create-assignment-rules-modal></ngx-create-assignment-rules-modal>
    <ngx-confirm-modal></ngx-confirm-modal>
    <ngx-edit-assignment-rules></ngx-edit-assignment-rules>
    </div>
    `
})
export class AppComponent implements OnInit, AfterViewInit {
  message: any;
  toasterConfig: ToasterConfig;
  menu = [];
  customStyles: string;
  testeandoinicio: string;
  previousUrl = '';
  currentUrl = '';

  constructor(
    private readonly authService: AuthService,
    private readonly messagingService: MessagingService,
    private readonly logUpdateService: LogUpdateService,
    private readonly promptUpdateService: PromptUpdateService,
    private readonly checkForUpdateService: CheckForUpdateService,
    private readonly toastService: ToastService,
    private readonly menuService: MenuService,
    private readonly translatorService: TranslatorService,
    private readonly sidebarManager: SidebarManagerService,
    private readonly chatService: ChatService,
    private readonly router: Router,
    private readonly titleService: Title,
    private readonly styleProvider: StylesProvider,
    private readonly nebularMomentService: NbMomentDateService,
    private readonly noticesService: NoticesService,
    protected readonly userService: UserService,
    //private readonly supportService: SupportService,
  ) {

    this.getCustomStyles();
    const user = this.authService.getUser();
    const locale = user ? user.language : language.defaultLocale;
    this.translatorService.setLanguage(locale);
    this.nebularMomentService.setLocale(locale);
    moment.locale(locale);
    this.messagingService.init();
    this.logUpdateService.init();
    this.promptUpdateService.init();
    this.checkForUpdateService.init();
    this.toasterConfig = this.toastService.getConfiguration();
    this.router.events.subscribe(event => {

      if (environment.stage !== 'dev' && event instanceof NavigationEnd) {
        (window as any).ga('set', 'page', event.urlAfterRedirects);
        (window as any).ga('send', 'pageview');
      }
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;

        if (!this.currentUrl.startsWith('/auth') || !this.currentUrl.startsWith('/auth/login')) {
          this.noticesService.init();
        }

        if (!((this.previousUrl.startsWith('/mylead') && this.currentUrl === '/leads') || (this.currentUrl.startsWith('/mylead') && this.previousUrl === '/leads'))) {
          localStorage.removeItem('numPag');
          localStorage.removeItem('pageSize');
        }
      }

    });

    if (environment.stage !== 'dev') {

      Sentry.init({
        dsn: environment.sentryUrl,
        // TryCatch has to be configured to disable XMLHttpRequest wrapping, as we are going to handle
        // http module exceptions manually in Angular's ErrorHandler and we don't want it to capture the same error twice.
        // Please note that TryCatch configuration requires at least @sentry/browser v5.16.0.
        integrations: [new Sentry.Integrations.TryCatch({
          XMLHttpRequest: false,
        })],
        environment: environment.stage,
      });
    }
  }

  ngOnInit(): void {
    //this.supportService.load();
    this.menu = this.menuService.getMenu();
    this.authService.resfreshNewUser.subscribe((getMenu) => {
      if (!getMenu) {
        this.menu = this.menuService.getMenu();
      }

    });

  }
  ngAfterViewInit(): void {
    this.sidebarManager.toggle();
  }

  private getCustomStyles() {
    this.customStyles = this.styleProvider.getClassWhiteBrand();
  }

}
